const SESSION_KEY = 'campaignHostLtdPromoDismissed';

export function isCampaignHostLtdPromoDismissed(): boolean {
    try {
        return sessionStorage.getItem(SESSION_KEY) === '1';
    } catch {
        return false;
    }
}

export function dismissCampaignHostLtdPromo(): void {
    try {
        sessionStorage.setItem(SESSION_KEY, '1');
    } catch {
        /* ignore */
    }
}

export function clearCampaignHostLtdPromoDismiss(): void {
    try {
        sessionStorage.removeItem(SESSION_KEY);
    } catch {
        /* ignore */
    }
}
